<script>
import {commonDict} from "@/utils/bizDict/commonDict";
import urlConfig from "@/utils/urlConfig";

export default {
  name: "acctregDetail",
  data() {
    return {
      headers: {
        token: this.$session.getItem("token"),
      },

      recognizeAllTextVerifyURL: urlConfig.busiURL + "/base/ocr/recognizeAllTextVerify",
      imageUrl: '',
      loading: false,
      verifyData: {},
      verifyRspData: {},

      previewVisible: false,
      previewImageUrl: '',
      previewImageType: '',
      id: this.$route.query.id,
      approval: this.$route.query.approval,
      detailData: {
        id: 0,
        channelNo: "",
        appNo: "",
        departmentId: 0,
        departmentCode: "",
        status: "",
        accountNo: "",
        accountName: "",
        accountClass: "",
        accountProperty: "",
        idCardNo: "",
        mobile: "",
        primaryAccount: "",
        bankNo: "",
        bankName: "",
        openLongitude: 0,
        openDimensions: 0,
        openIp: "",
        extParams: "",
        rejectReason: "",
        auditorId: 0,
        auditTime: "",
        createTime: "",
        creater: "",
        updateTime: "",
        updater: "",
        recordStatus: "",
        files: [
          {
            id: 0,
            applicationId: 0,
            fileNo: "",
            fileType: "",
            filePage: 0,
            fileUrl: "",
            createTime: "",
            creater: "",
            updateTime: "",
            updater: "",
            recordStatus:  "",
          }
        ],
        logs: [
          {
            id: "",
            applicationId:  "",
            fromStatus: "",
            toStatus: "",
            operatorId: 0,
            remark: "",
            operationTime: "",
            createTime: "",
            creater: "",
            updateTime: "",
            updater: "",
            recordStatus:  "",
          }
        ],
        enterpriseInfo: {
          applicationId:  "",
          creditCode: "",
          orgcodes: "",
          ratcodes: "",
          zsopscope: "",
          industry: "",
          religiousCertNo: "",
          religiousType: "",
          backupAccount: "",
          legalRepIdType: "",
          legalRepIdNo: "",
          legalRepName: "",
          controllerIdType: "",
          controllerIdNo: "",
          controllerIdName: "",
          controllerOpto: "",
          leaderIdType: "",
          leaderIdNo: "",
          leaderIdName: "",
          leaderMobile: "",
          leaderOpto: "",
          operatorIdType: "",
          operatorIdNo: "",
          operatorName: "",
          operatorMobile: "",
          beneName: "",
          beneSex: "",
          beneNationality: "",
          beneIsShareholder: "",
          beneRatio: "",
          beneAddr: "",
          beneIdType: "",
          beneIdNo: "",
          beneOpto: "",
          beneOwner: "",
          createTime: "",
          creater: "",
          updateTime: "",
          updater: "",
          recordStatus:  ""
        },
        identityInfo: {
          applicationId:  "",
          idType: "",
          idNo: "",
          idStartDate: "",
          idEndDate: "",
          signNo: "",
          signName: "",
          idAddress: "",
          sex: "",
          ethnic: "",
          job: "",
          jobNote: "",
          createTime: "",
          creater: "",
          updateTime: "",
          updater: "",
          recordStatus:  "",
        }
      },
      logColumns: [
        { title: "操作时间", dataIndex: "operationTime", align: "center", width: 150 },
        {
          title: "原状态",
          dataIndex: "fromStatus",
          align: "center",
          customRender: (text) => this.getStatusLabel(text),
        },
        {
          title: "变更后状态",
          dataIndex: "toStatus",
          align: "center",
          customRender: (text) =>
              <a-tag color={this.getStatusColor(text)}>{this.getStatusLabel(text)}</a-tag>,
        },
        { title: "操作说明", dataIndex: "remark", align: "center" },
      ],

      approvalVisible: false,
      approvalLoading: false,
      approvalStatus: null,
      approvalRemark: '',
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    back() {
      //回到上一页
      this.$router.go(-1)
    },

    showApprovalModal() {
      this.approvalVisible = true;
      this.approvalStatus = null;
      this.approvalRemark = '';
    },
    handleApprovalSubmit() {
      if (!this.approvalStatus) {
        this.$message.warning('请选择审批结果');
        return;
      }
      const payload = {
        applicationId: this.detailData.id,
        action: this.approvalStatus,
        reason: this.approvalRemark
      };
      this.approvalLoading = true;
      this.api.approvalAcctReg(payload)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(res.info || '审批成功');
              this.approvalVisible = false;
              this.getDetail();// 刷新详情
            } else {
              this.$message.error(res.info || '审批失败');
            }
          })
          .catch(err => {
            console.error(err);
            this.$message.error('审批请求失败');
          })
          .finally(() => {
            this.approvalLoading = false;
          });
    },
    async getDetail() {
      await this.api.getAcctRegDetail({id:this.id}).then(res => {
        if (res.code == 200) {
          this.detailData = res.data

          this.verifyData = {
            accountName: this.detailData.accountName,
            creditCode: this.detailData.enterpriseInfo.creditCode,
            religiousDharmaName: this.detailData.enterpriseInfo.religiousDharmaName,
            religiousSecularName: this.detailData.enterpriseInfo.religiousSecularName,
            idAddress: this.detailData.enterpriseInfo.idAddress,
          }
        }
      })
    },
    getStatusLabel(status) {
      const config = commonDict.AcctRegStatusConfig[status];
      return config ? config?.label : status || '--';
    },
    getStatusColor(status) {
      const config = commonDict.AcctRegStatusConfig[status];
      return config ? config?.color : 'default';
    },
    getFileTypeLabel(fileType) {
      return commonDict.fileTypeList[fileType]?.label || '附件';
    },

    getgetReligiousTypeLabel(religiousType) {
      const config = commonDict.religionTypes[religiousType];
      return config ? config?.label : status || '--';
    },
    getReligiousTypeColor(religiousType) {
      const config = commonDict.religionTypes[religiousType];
      return config ? config.color : 'default';
    },


    /**
     * 判断是否为图片类型
     * @param {string} url
     * @returns {boolean}
     */
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|bmp|webp)$/i.test(url.split('?')[0]);
    },
    /**
     * 点击附件预览或下载
     * @param {string} fileUrl
     */
    handlePreview(fileUrl,fileType) {
      if (this.isImage(fileUrl)) {
        this.previewImageUrl = fileUrl;
        this.previewImageType = fileType;
        this.previewVisible = true;
      } else {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileUrl.split('/').pop().split('?')[0];
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    recognizeAllTextVerify: function (info) {
      if (info.file.status === 'uploading' && !this.loading) {
        this.$message.info(`识别中，请稍候`);
        this.loading = true
      }
      if (info.file.status === 'done') {
        this.loading = false
        if (info.file.response.code === 200) {
          this.$message.success(`${info.file.name} 识别成功,请核对信息`);
          this.verifyRspData = info.file.response.data.ocrVerifyResult;
          this.imageUrl = info.file.response.data.file_path;
          console.log("this.verifyRspData", this.verifyRspData)

        } else {
          this.$message.error(`上传失败: ${info.file.response.message || '未知错误'}`);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },


  }

}
</script>

<template>
  <div>
    <!-- 企业开户 -->
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>开户登记信息查看</span>
            <a-icon type="right"/>
            <span><span class="title" style="color: #02a7f0">{{detailData.accountName}}</span></span>
          </div>
          <div style="display: flex">
            <div class="right">
              <a-button type="primary" @click="back"> 返回</a-button>
              <a-button type="danger"  @click="showApprovalModal" v-if="$authority('acctreg-approval') && detailData.status === 'PENDING' && approval" >审批</a-button>
            </div>
          </div>
        </div>
      </template>
      <div style="margin-top: 20px; display: flex; gap: 20px; flex-wrap: wrap;">
        <!-- 左边内容 - 占2/3宽度 -->
        <div style="flex: 2; min-width: 300px;">
          <!-- 基本信息 -->
          <a-divider orientation="left">基本信息</a-divider>
          <a-descriptions bordered size="small" :column="2">
            <a-descriptions-item label="户名">{{ detailData.accountName || '---' }}</a-descriptions-item>

            <a-descriptions-item label="证件号码">{{ detailData.idNo || '---' }}</a-descriptions-item>
            <a-descriptions-item label="宗教类型">
              <a-tag :color="getReligiousTypeColor(detailData?.enterpriseInfo?.religiousType)">
                {{ getgetReligiousTypeLabel(detailData?.enterpriseInfo?.religiousType) }}
              </a-tag>
            </a-descriptions-item>

            <a-descriptions-item label="手机号">{{ detailData.mobile || '---' }}</a-descriptions-item>
            <a-descriptions-item label="开户状态">
              <a-tag :color="getStatusColor(detailData.status)">
                {{ getStatusLabel(detailData.status) }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="银行卡号">{{ detailData.primaryAccount || '---' }}</a-descriptions-item>
            <a-descriptions-item label="创建时间">{{ detailData.createTime || '---' }}</a-descriptions-item>

            <a-descriptions-item label="开户行">{{detailData.bankName || '---'}}</a-descriptions-item>
            <a-descriptions-item label="审核时间">{{ detailData.auditTime || '---' }}</a-descriptions-item>

            <a-descriptions-item label="开户行号">{{ detailData.bankNo || '---' }}</a-descriptions-item>
            <a-descriptions-item label="驳回原因" :span="2">{{ detailData.rejectReason || '---' }}</a-descriptions-item>
          </a-descriptions>

          <!-- 个人信息 -->
          <template v-if="detailData.accountProperty === '1'">
            <a-divider orientation="left">个人信息</a-divider>
            <a-descriptions bordered size="small" :column="2">
              <a-descriptions-item label="性别">
                {{
                  detailData.identityInfo.sex === '0' ? '男' :
                      detailData.identityInfo.sex === '1' ? '女' : '---'
                }}
              </a-descriptions-item>
              <a-descriptions-item label="民族">{{ detailData.identityInfo.ethnic || '---' }}</a-descriptions-item>
              <a-descriptions-item label="职业">{{ detailData.identityInfo.job || '---' }}</a-descriptions-item>
              <a-descriptions-item label="签发机关">{{ detailData.identityInfo.signName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="证件有效期">
                {{ detailData.identityInfo.idStartDate || '---' }} ~ {{ detailData.identityInfo.idEndDate || '---' }}
              </a-descriptions-item>
              <a-descriptions-item label="证件地址" :span="2">{{ detailData.identityInfo.idAddress || '---' }}</a-descriptions-item>
            </a-descriptions>
          </template>

          <!-- 企业/宗教信息 -->
          <template v-if="detailData.accountProperty === '2' || detailData.accountProperty === '3'">
            <a-divider orientation="left">企业/宗教信息</a-divider>
            <a-descriptions bordered size="small" :column="2">
              <a-descriptions-item label="统一社会信用代码">{{ detailData.enterpriseInfo.creditCode || '---' }}</a-descriptions-item>
              <a-descriptions-item label="宗教场所登记证号">{{ detailData.enterpriseInfo.religiousCertNo || '---' }}</a-descriptions-item>
              <a-descriptions-item label="税务登记证号码">{{ detailData.enterpriseInfo.ratcodes || '---' }}</a-descriptions-item>
              <a-descriptions-item label="组织机构代码">{{ detailData.enterpriseInfo.orgcodes || '---' }}</a-descriptions-item>
              <a-descriptions-item label="行业类别">{{ detailData.enterpriseInfo.industry || '---' }}</a-descriptions-item>
              <a-descriptions-item label="法定代表人">{{ detailData.enterpriseInfo.legalRepName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="法代证件号码">{{ detailData.enterpriseInfo.legalRepIdNo || '---' }}</a-descriptions-item>
              <a-descriptions-item label="负责人姓名">{{ detailData.enterpriseInfo.leaderIdName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="负责人手机号">{{ detailData.enterpriseInfo.leaderMobile || '---' }}</a-descriptions-item>
              <a-descriptions-item label="经办人姓名">{{ detailData.enterpriseInfo.operatorName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="经办人手机号">{{ detailData.enterpriseInfo.operatorMobile || '---' }}</a-descriptions-item>
              <a-descriptions-item label="经营范围" :span="2">{{ detailData.enterpriseInfo.zsopscope || '---' }}</a-descriptions-item>
              <a-descriptions-item label="地址" :span="2">{{ detailData.enterpriseInfo.idAddress || '---' }}</a-descriptions-item>
            </a-descriptions>

            <!-- 受益人信息 -->
            <a-divider v-if="detailData.accountProperty === '2'" orientation="left">受益人信息</a-divider>
            <a-descriptions bordered size="small" :column="2" v-if="detailData.accountProperty === '2'">
              <a-descriptions-item label="姓名">{{ detailData.enterpriseInfo.beneName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="性别">
                {{
                  detailData.enterpriseInfo.beneSex === '0' ? '男' :
                      detailData.enterpriseInfo.beneSex === '1' ? '女' : '---'
                }}
              </a-descriptions-item>
              <a-descriptions-item label="国籍">{{ detailData.enterpriseInfo.beneNationality || '中国' }}</a-descriptions-item>
              <a-descriptions-item label="是否股东">
                {{
                  detailData.enterpriseInfo.beneIsShareholder === '1' ? '是' :
                      detailData.enterpriseInfo.beneIsShareholder === '2' ? '否' : '---'
                }}
              </a-descriptions-item>
              <a-descriptions-item label="持股比例">{{ detailData.enterpriseInfo.beneRatio || '---' }}</a-descriptions-item>
              <a-descriptions-item label="证件类型">{{ detailData.enterpriseInfo.beneIdType || '---' }}</a-descriptions-item>
              <a-descriptions-item label="证件号码">{{ detailData.enterpriseInfo.beneIdNo || '---' }}</a-descriptions-item>
              <a-descriptions-item label="证件有效期">{{ detailData.enterpriseInfo.beneOpto || '---' }}</a-descriptions-item>
              <a-descriptions-item label="受益人地址" :span="2">{{ detailData.enterpriseInfo.beneAddr || '---' }}</a-descriptions-item>
            </a-descriptions>

            <!-- 负责人信息 -->
            <a-divider v-if="detailData.accountProperty === '3'" orientation="left">负责人信息</a-divider>
            <a-descriptions bordered size="small" :column="2">
              <a-descriptions-item label="姓名">{{ detailData.enterpriseInfo.leaderIdName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="证件号">{{ detailData.enterpriseInfo.leaderIdNo || '---' }}</a-descriptions-item>
              <a-descriptions-item label="俗名">{{ detailData.enterpriseInfo.religiousSecularName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="法名">{{ detailData.enterpriseInfo.religiousDharmaName || '---' }}</a-descriptions-item>
              <a-descriptions-item label="手机号">{{ detailData.enterpriseInfo.leaderMobile || '---' }}</a-descriptions-item>
              <a-descriptions-item label="证件有效期止">{{ detailData.enterpriseInfo.leaderOpto || '---' }}</a-descriptions-item>
            </a-descriptions>
          </template>

          <!-- 附件资料 -->
          <a-divider orientation="left">附件资料</a-divider>
          <div style="display: flex; flex-wrap: wrap; gap: 10px;">
            <template v-if="detailData.files && detailData.files.length">
              <div v-for="file in detailData.files" :key="file.id || file.fileNo" style="width: 110px; text-align: center; cursor: pointer;"
                   @click="handlePreview(file.fileUrl,file.fileType)">
                <!-- ✅ 图片预览，非图片显示文件图标 -->
                <template v-if="isImage(file.fileUrl)">
                  <img :src="file.fileUrl" alt="预览" style="width: 100%; height: 80px; object-fit: cover; border-radius: 4px;"/>
                </template>
                <template v-else>
                  <div
                      style=" width: 100%; height: 80px; display: flex; align-items: center; justify-content: center; background: #fafafa; border-radius: 4px;">
                    <a-icon type="file" style="font-size: 32px; color: #999;"/>
                  </div>
                </template>
                <div style="font-size: 14px; margin-top: 4px;">
                  {{ getFileTypeLabel(file.fileType) }}
                </div>
              </div>
            </template>
            <span v-else>无附件</span>
          </div>

          <!-- 状态变更日志 -->
          <a-divider orientation="left">状态变更日志</a-divider>
          <a-table
              size="small"
              :columns="logColumns"
              :data-source="detailData.logs || []"
              rowKey="id"
              bordered
              :pagination="false"
          />
        </div>

        <!-- 右边内容 - 占1/3宽度 -->
        <div style="flex: 1; min-width: 300px;">
          <!-- 信息核验 -->
          <a-divider orientation="left">信息核验</a-divider>
          <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
            <a-form-item label="文件上传">
              <a-upload-dragger
                  name="file"
                  list-type="picture-card"
                  class="invoice-uploader"
                  :show-upload-list="false"
                  :action="recognizeAllTextVerifyURL"
                  :headers="headers"
                  :data="{jsonData: JSON.stringify(verifyData)}"
                  @change="recognizeAllTextVerify"
                  accept="image/*,.pdf,.PDF"
              >
                <img v-if="imageUrl" :src="imageUrl" alt="非图片宗教活动场所登记证，无法预览" class="ant-upload ant-upload-select ant-upload-select-picture-card"/>
                <div v-else>
                  <p class="ant-upload-drag-icon">
                    <a-icon :type="loading ? 'loading' : 'inbox'"/>
                  </p>
                  <div class="ant-upload-text">
                    拖入或点击上传宗教活动场所登记证，支持图片与pdf
                  </div>
                </div>
              </a-upload-dragger>
            </a-form-item>

            <!-- 通用文字统一识别校验 -->
            <a-form-item label="核验结果" v-if="Object.keys(verifyRspData).length > 0">
              <div style="background-color: #f0f2f5; padding: 10px; border-radius: 4px;">
                <template v-for="(value, key) in verifyRspData">
                  <p :key="key">
                    {{ key }} - <span :style="{ color: value ? '#52c41a' : '#ff4d4f' }">
                {{ value ? '通过' : '未通过' }}
              </span>
                  </p>
                </template>
              </div>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-card>
    <!-- 图片预览 modal -->
    <a-modal
        :visible="previewVisible"
        :maskClosable="true"
        centered
        width="auto"
        @cancel="previewVisible = false"
        wrapClassName="preview-modal-wrapper"
    >
      <div class="preview-content">
        <div class="preview-info compact-center" v-if="previewImageType==='103'">
          <a-descriptions size="small" :column="2" class="bold-descriptions">
            <a-descriptions-item label="俗名">
              {{detailData.enterpriseInfo.religiousSecularName || '---'}}
            </a-descriptions-item>
            <a-descriptions-item label="法名">
              {{detailData.enterpriseInfo.religiousDharmaName || '---'}}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="preview-info compact-center" v-if="previewImageType==='01' && detailData.accountProperty === '3'">
          <a-descriptions size="small" :column="2" class="bold-descriptions">
            <a-descriptions-item label="法人姓名">
              {{detailData.enterpriseInfo.leaderIdName || '---'}}
            </a-descriptions-item>
            <a-descriptions-item label="法人证件号码">
              {{detailData.enterpriseInfo.legalRepIdNo || '---'}}
            </a-descriptions-item>
          </a-descriptions>
        </div>

        <div class="image-container">
          <img :src="previewImageUrl" alt="预览" class="preview-image"/>
        </div>
      </div>
    </a-modal>


    <!-- 审批弹窗 -->
    <a-modal
        v-model="approvalVisible"
        title="开户审批"
        :confirm-loading="approvalLoading"
        @ok="handleApprovalSubmit"
        @cancel="approvalVisible = false"
        ok-text="确认审批"
        cancel-text="取消"
    >
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="审批结果">
          <a-radio-group v-model="approvalStatus">
            <a-radio value="APPROVED">通过并开户</a-radio>
            <a-radio value="REJECTED">审核拒绝</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea
              v-model="approvalRemark"
              placeholder="请输入备注（可选）"
              :rows="4"
              allow-clear
          />
        </a-form-item>
      </a-form>
    </a-modal>


  </div>
</template>

<style scoped lang="less">
.top-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    span {
      &:first-child {
        font-size: 15px;
        font-weight: 700;
      }

      // &:last-child {}
    }
  }

  .agreement {
    /deep/.ant-checkbox-wrapper {
      margin-right: 2px;
    }

    margin-right: 100px;
    display: flex;
    align-items: center;

    .item {
      margin-left: 15px;

      span {
        &:hover {
          line-height: 20px;
          color: #40a9ff;
          border-bottom: 1px solid #40a9ff;
        }
      }
    }
  }

  .right {
    button {
      height: 38px;
      border: none;

      &:first-child {
        width: 108px;

        color: #ffff;
      }

      &:last-child {
        width: 108px;
        color: #ffff;
      }
    }
  }
}

.detail-container {
  display: flex;
  gap: 20px;

  .left-panel {
    flex: 2;
    min-width: 0; // 防止内容溢出
  }

  .right-panel {
    flex: 1;
    min-width: 0; // 防止内容溢出
  }
}

img {
  cursor: pointer;
}

.preview-modal-wrapper {
  .ant-modal {
    display: flex;
    flex-direction: column;
    align-items: center;

    .ant-modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: transparent;
      box-shadow: none;

      .ant-modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
      }
    }
  }
}

.preview-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 4px;
  padding: 16px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  .preview-image {
    max-width: 80vw;
    max-height: 70vh;
    display: block;
  }
}

.preview-info {
  text-align: center;
  width: 100%;

  &.compact-center {
    padding: 8px 0;

    .bold-descriptions {
      display: inline-block;
      text-align: left;

      /deep/ .ant-descriptions-row > th,
      /deep/ .ant-descriptions-row > td {
        padding-bottom: 4px;
        padding-top: 4px;
      }

      /deep/ .ant-descriptions-item-label {
        font-weight: 500;
        padding-right: 8px;
        width: auto !important;
      }

      // 添加文字加粗样式
      /deep/ .ant-descriptions-item-content,
      /deep/ .ant-descriptions-item-label {
        font-weight: bold;
      }
    }
  }
}



</style>